@if (!videoReady) {
  <app-loading></app-loading>
}
<div
  class="video-wrapper"
  [class.no-transcript]="!attachment.subtitles"
  [class.ready]="videoReady"
>
  <ng-container [ngSwitch]="playerType">
    <!-- Video Attachment -->
    <ng-container *ngSwitchCase="'video'">
      <video
        #videoPlayer
        class="video-js vjs-theme-city vjs-big-play-centered"
        controls
        fluid
        responsive
        preload="none"
        [autoplay]="autoplay"
        width="640"
        height="364"
        [src]="videoUrl"
      ></video>

      <div class="video-player-transcript" *ngIf="attachment.subtitles">
        <div class="flex">
          <div id="vjs-transcribe-selector-{{ postId }}"></div>
          <div id="vjs-transcribe-search-{{ postId }}"></div>
        </div>
        <div id="vjs-transcribe-{{ postId }}"></div>
      </div>
    </ng-container>

    <!-- Youtube Video -->
    <ng-container *ngSwitchCase="'youtube'">
      @if (isVisible || videoReady) {
        <app-youtube-player
          [videoId]="attachment.youtube_video_id"
          [autoplay]="autoplay"
        ></app-youtube-player>
      } @else {
        <div class="video-placeholder"></div>
      }
    </ng-container>
    <!-- External Video -->
    <ng-container *ngSwitchCase="'external'">
      <ng-container *ngIf="!showIframe; else iframeTemplate">
        <div class="thumbnail-container" (click)="showIframe = true">
          <img
            [src]="attachment.image_src"
            alt="Video Thumbnail"
            class="thumbnail-image"
          />
          <div class="play-button">
            <!-- Inline SVG play icon -->
            <svg width="50" height="50" viewBox="0 0 100 100" fill="#fff">
              <circle cx="50" cy="50" r="48" fill="rgba(0,0,0,0.6)"></circle>
              <polygon points="40,30 70,50 40,70" fill="#fff"></polygon>
            </svg>
          </div>
        </div>
      </ng-container>
      <ng-template #iframeTemplate>
        <iframe
          #videoIframe
          frameborder="0"
          preload="auto"
          width="100%"
          height="380"
          [src]="videoUrl"
        ></iframe>
      </ng-template>
    </ng-container>

    <ng-container *ngSwitchCase="'sensika'">
      <video
        #videoPlayer
        class="video-js vjs-theme-city vjs-big-play-centered"
        controls
        fluid
        responsive
        preload="none"
        [autoplay]="autoplay"
        width="640"
        height="364"
        [src]="videoUrl"
        [attr.poster]="attachment?.image_src"
      ></video>
      @if (videoReady && !!attachment?.transcript) {
        <div class="transcript" style="min-width: 40%">
          <div id="vjs-transcribe-{{ attachmentId }}"></div>
          <div id="vjs-transcribe-search-{{ attachmentId }}"></div>
          <div id="vjs-transcribe-download-{{ attachmentId }}"></div>
        </div>
      }
    </ng-container>
  </ng-container>
</div>
